// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store'

import vivus from 'vivus'


Vue.config.productionTip = false;
Vue.use(Vuex);

window.debug = true;

/**
 * Log helper
 * @param val
 */
Vue.prototype.log = (val) => {
  if (window.debug) {
    console.log(val);
  }
};


// helper para inputs com placeholder flutuante
Vue.directive('fakelabel', {
  inserted: function (el) {
    el.onfocus = (event) => {
      el.parentNode.classList.add('focus');
    };
    el.onblur = (event) => {
      el.parentNode.classList.remove('focus');

      if (el.value && el.value.length > 0) {
        el.classList.add('dirty');
      } else {
        el.classList.remove('dirty');
      }
    };

    let event = new Event('blur');
    el.dispatchEvent(event);
  }
});

// helper para inputs com placeholder flutuante
Vue.directive('magicheck', {
  inserted: function (el) {
    let anim = new vivus(el, {
      start: 'manual', // avoid memory leak on scroll event
      duration: 5,
      animTimingFunction: vivus.EASE_IN,
    });
    anim.reset().stop();
   $(el).bind('drawsvg', ()=>{
      anim.reset().stop().play();
    });
  }
});

// Vue.directive('parentfocusclass', {
//   inserted: function (el) {
//     el.onfocus = (event) => {
//       el.parentNode.classList.add('focus');
//     };
//     el.onblur = (event) => {
//       el.parentNode.classList.remove('focus');
//     };
//   }
// });


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  // template: '<App/>',
  template: '<router-view/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js